import moment from "moment";
import request from "./utils/request";
import { roleId, urls } from "../constants/app";
import { setError } from "./errors";
import { isEmpty } from "lodash";
import { parseNumToFixed } from "../utils/common";

export const getDataCursorPaging = async (params, requestData, sendIdgt) => {
    const _limit = 400;
    let hasMore = true;
    let result = [];
    let lastId = null;

    try {
        while (hasMore) {
            const requestParams = {
                method: requestData.method, 
                url: requestData.url, 
            }

            if (requestData.method === 'post') {
                if (!sendIdgt)  {
                    requestParams.data = { ...params, lastId, _limit };
                } else {
                    requestParams.data = { ...params, 'id_gt': lastId, _limit };
                }
            } else {
                if (!sendIdgt) {
                    requestParams.params = { ...params, lastId, _limit };
                } else {
                    requestParams.params = { ...params, 'id_gt': lastId, _limit };
                }
            }

            const response = await request(requestParams);
            
            if (!Array.isArray(response) || response.length === 0) {
                hasMore = false;
                break;
            } else {
                result = [...result, ...response];
                lastId = response[response.length - 1].id;
                
                const delay = response.length === _limit ? 50 : 0;
                if (delay > 0) {
                    await new Promise(resolve => setTimeout(resolve, delay));
                } else {
                    hasMore = false;
                }
            }
        }
        return result;
    } catch (error) {
        return {error: error};
    }
};

export function setReportsFilters(name, filters) {
    return (dispatch) => {
        dispatch({ type: 'SET_REPORTS_FILTERS', name, filters });
    }
}

export function setReportsPaging(name, paging) {
    return dispatch => {
        dispatch({ type: 'SET_REPORTS_PAGING', name, paging });
    }
}

export function resetReportsFilters(name) {
    return (dispatch) => {
        dispatch({ type: 'RESET_REPORTS_FILTERS', name });
    }
}

export function fetchReportPlannedRevenue(dataParams = {}, fieldReport, loader) {
    return async (dispatch) => {
        try {
            const start = `${moment(dataParams.created_at_gte).startOf('month').format('YYYY-MM-DD')}T00:00:00.000Z`;
            const end = `${moment(dataParams.created_at_lte).endOf('month').format('YYYY-MM-DD')}T23:59:59.000Z`;
            const params = {
                'pointId_in': dataParams.pointsId,
                startOfMonthDate_lte: new Date(end),
                startOfMonthDate_gte: new Date(start),
            };
            const result = await request({ method: 'get', url: urls.plannedRevenues, params });
            dispatch({ type: 'SET_REPORTS_FIELD', name: fieldReport, field: 'plan', data: result });
            dispatch({ type: loader.type, name: loader.name, loading: loader.finally });
        } catch (error) {
            dispatch({ type: loader.type, name: loader.name, loading: loader.finally });
            dispatch(setError(error, fieldReport));
            return false
        }
    }
}

export function fetchReportRevenue(dataParams = {}, fieldReport) {
    return async (dispatch, getState) => {
        dispatch({ type: 'SET_REPORTS_LOADER', name: fieldReport, loading: true });
        dispatch({ type: 'SET_ERROR', name: fieldReport, error: null });
        const filters = getState().reports[fieldReport].filters;
        const points = getState().handbook.filials;
        const zones = getState().handbook.zones;
        const zonesArray = [...(zones || [])];

        if(!filters.created_at_gte) filters.created_at_gte = moment().endOf('day');
        if(!filters.created_at_lte) filters.created_at_lte = moment().startOf('day');
        
        const params = { ...dataParams };
        if (filters.created_at_gte) params['created_at_gte'] = moment(filters.created_at_gte).format('YYYY-MM-DD HH:mm:ss');
        if (filters.created_at_lte) params['created_at_lte'] = moment(filters.created_at_lte).format('YYYY-MM-DD HH:mm:ss');

        if (filters.points && filters.points.length > 0) {
            const pointsId = filters.points.map((point) => point.value).filter((item) => item);
            params.pointsId = pointsId;
        } else if (filters.point) {
            params.pointsId = [filters.point];
        } else if (filters.regionalDirectors && filters.regionalDirectors.length > 0) {
            const pointsId = filters.regionalDirectors.flatMap((dir) => {
                if (dir && dir.points) {
                    const points = dir.points.map((point) => {
                        if (point) {
                            if (point.id) return point.id;
                            return point;
                        }
                        return null;
                    }).filter((item) => item);
                    return points;
                }
                return null;
            }).filter((item) => item);
            params.pointsId = pointsId;
        }

        if (filters.deliveryMethod) params.deliveryMethod = filters.deliveryMethod;
        if (filters.courierId) params.courierId = filters.courierId;

        if (filters.promotions && filters.promotions.length > 0) {
            const promotionsId = filters.promotions.map((promotion) => promotion.value).filter((item) => item);
            params.promotionsId = promotionsId;
        }

        if (filters.promocodes && filters.promocodes.length > 0) {
            const promocodesId = filters.promocodes.map((promocode) => promocode.value).filter((item) => item);
            params.promocodesId = promocodesId;
        }

        if (filters.users) {
            const usersValue = filters.users.value;
            if (usersValue && usersValue !== 'all') params.authorizedType = usersValue;
        }

        if (filters.status) params.status = filters.status;
        if (filters.status_nin) params.status_nin = filters.status_nin;

        const orders = await getDataCursorPaging(params, {method: 'post', url: `${urls.orders}/listReport`});
        if (orders.error) {
            dispatch({ type: 'SET_REPORTS_LOADER', name: fieldReport, loading: false });
            dispatch(setError(orders.error, fieldReport));
            return false;
        }
        const archive = await getDataCursorPaging(params, {method: 'post', url: `${urls.archive}/listReport`});
        if (archive.error) {
            dispatch({ type: 'SET_REPORTS_LOADER', name: fieldReport, loading: false });
            dispatch(setError(archive.error, fieldReport));
            return false;
        }

        const getPoint = (order, id) => {
            const point = points.find((filial) => filial.id === id);
            if (!point) return { ...order, point: null}
            return { ...order, point, zone: null };
        }

        const result = await Promise.all([...(orders || []), ...(archive || [])].map(async (order) => {
            if (!order.point && !order.zone) return order;
            if (!isEmpty(order.aggData) && typeof order.aggData === 'string') order.aggData = JSON.parse(order.aggData);
            if (order.point) {
                if (order.point.id) return order;
                return getPoint(order, order.point)
            }
            if (order.zone) {
                if (order.zone.id) {
                    if (order.zone.point) {
                        if (order.zone.point.id) return { ...order, point: order.zone.point };
                        return getPoint(order, order.zone.point)
                    }
                }
                let zone = zonesArray.find((z) => z.id === order.zone);
                if (zone && zone.id && zone.point) {
                    if (zone.point.id) return { ...order, point: zone.point };
                    return getPoint(order, zone.point)
                } else {
                    zone = await request({ method: 'get', url: `${urls.zone}/${order.zone}` }).catch(() => null);
                    if (zone) {
                        zonesArray.push(zone);
                        if (zone.point.id) return { ...order, point: zone.point };
                        return getPoint(order, zone.point)
                    }
                }
            }
            return { ...order, point: null, zone: null };
        }));
        dispatch({ type: 'SET_REPORTS', name: fieldReport, result });

        if (filters.getPlan) {
            await dispatch(fetchReportPlannedRevenue(params, fieldReport, {type: 'SET_REPORTS_LOADER', name: fieldReport, finally: false}));
        } else {
            dispatch({ type: 'SET_REPORTS_LOADER', name: fieldReport, loading: false });
        }
    }
}

export function fetchReportInvoices(dataParams = {}, fieldReport) {
    return async (dispatch, getState) => {
        dispatch({ type: 'SET_REPORTS_LOADER', name: fieldReport, loading: true });
        const filters = getState().reports[fieldReport].filters;

        if(!filters.created_at_gte) filters.created_at_gte = moment().endOf('day').toDate();
        if(!filters.created_at_lte) filters.created_at_lte = moment().startOf('day').toDate();
        
        const params = { ...dataParams };
        params.date_lte = filters.created_at_lte;
        params.date_gte = filters.created_at_gte;

        if (filters.points && filters.points.length > 0) {
            const pointsId = filters.points.map((point) => point.value).filter((item) => item);
            params.pointsId = pointsId;
        } else if (filters.point) {
            params.pointsId = [filters.point];
        } else if (filters.regionalDirectors && filters.regionalDirectors.length > 0) {
            const pointsId = filters.regionalDirectors.flatMap((dir) => {
                if (dir && dir.points) {
                    const points = dir.points.map((point) => {
                        if (point) {
                            if (point.id) return point.id;
                            return point;
                        }
                        return null;
                    }).filter((item) => item);
                    return points;
                }
                return null;
            }).filter((item) => item);
            params.pointsId = pointsId;
        }

        try {
            const result = await getDataCursorPaging(params, {method: 'post', url: `${urls.invoiceforms}/listReport`});
            if (result.error) {
                dispatch({ type: 'SET_REPORTS_LOADER', name: fieldReport, loading: false });
                dispatch(setError(result.error, fieldReport));
                return false;
            }
            dispatch({ type: 'SET_REPORTS_FIELD', name: fieldReport, field: 'invoices', data: result });
            dispatch({ type: 'SET_REPORTS_LOADER', name: fieldReport, loading: false });
            return true;
        } catch (error) {
            dispatch(setError(error, fieldReport));
            dispatch({ type: 'SET_REPORTS_LOADER', name: fieldReport, loading: false });
            return false;
        }        
    }
}

export function fetchReportPromotions(fieldReport) {
    return async (dispatch) => {
        try {
            const result = await getDataCursorPaging({ _sort: 'id:asc'}, {method: 'get', url: `${urls.promotion}`});
            if (result.error) {
                dispatch({ type: 'SET_REPORTS_LOADER', name: fieldReport, loading: false });
                dispatch(setError(result.error, fieldReport));
                return false;
            }
            dispatch({ type: 'SET_REPORTS_FIELD', name: fieldReport, field: 'promotions', data: result });
            dispatch({ type: 'SET_REPORTS_LOADER', name: fieldReport, loading: false });
            return true;
        } catch (error) {
            dispatch(setError(error, fieldReport));
            dispatch({ type: 'SET_REPORTS_LOADER', name: fieldReport, loading: false });
            return false;
        }
    }
}

export function fetchReportPromocodes(fieldReport) {
    return async (dispatch) => {
        try {
            const result = await getDataCursorPaging({ mainType: 'reusable', _sort: 'id:asc', isCrm: true }, {method: 'get', url: `${urls.promocodes}`}, true);
            if (result.error) {
                dispatch({ type: 'SET_REPORTS_LOADER', name: fieldReport, loading: false });
                dispatch(setError(result.error, fieldReport));
                return false;
            }
            dispatch({ type: 'SET_REPORTS_FIELD', name: fieldReport, field: 'promocodes', data: result });
            dispatch({ type: 'SET_REPORTS_LOADER', name: fieldReport, loading: false });
            return true;
        } catch (error) {
            dispatch(setError(error, fieldReport));
            dispatch({ type: 'SET_REPORTS_LOADER', name: fieldReport, loading: false });
            return false;
        }
    }
}

export function fetchCashbackReport(fieldReport) {
    return async (dispatch, getState) => {
        try {
            dispatch({ type: 'SET_REPORTS_LOADER', name: fieldReport, loading: true });
            dispatch({ type: 'SET_ERROR', name: fieldReport, error: null });
            const filters = getState().reports[fieldReport].filters;

            if(!filters.created_at_gte) filters.created_at_gte = moment().endOf('day').toDate();
            if(!filters.created_at_lte) filters.created_at_lte = moment().startOf('day').toDate();
            
            const params = {};
            params.created_at_lte = filters.created_at_lte;
            params.created_at_gte = filters.created_at_gte;
            if(filters.lvls) params['cashbackLevel_in'] = filters.lvls.map((item) => item.value);
            if (filters.type && filters.type.value !== 'all') params.operationType = filters.type.value;
            if (filters.cities && filters.cities.length > 0) params.citiesIds = filters.cities.map((city) => city.value);
            params._sort = 'id:asc'

            const result = await getDataCursorPaging(params, {method: 'post', url: `${urls.cashbacklogs}/listReport`}, true);
            if (result.error) {
                dispatch({ type: 'SET_REPORTS_LOADER', name: fieldReport, loading: false });
                dispatch(setError(result.error, fieldReport));
                return false;
            }

            dispatch({ type: 'SET_REPORTS', name: fieldReport, result });
            dispatch({ type: 'SET_REPORTS_LOADER', name: fieldReport, loading: false });
            return true;
        } catch (error) {
            dispatch(setError(error, fieldReport));
            dispatch({ type: 'SET_REPORTS_LOADER', name: fieldReport, loading: false });
            return false;
        }
    }
}

export function fetchCashbackNewReport(fieldReport) {
    return async (dispatch, getState) => {
        try {
            dispatch({ type: 'SET_REPORTS_LOADER', name: fieldReport, loading: true });
            dispatch({ type: 'SET_ERROR', name: fieldReport, error: null });
            const filters = getState().reports[fieldReport].filters;

            if(!filters.created_at_gte) filters.created_at_gte = moment().endOf('day').toDate();
            if(!filters.created_at_lte) filters.created_at_lte = moment().startOf('day').toDate();
            
            const params = {};
            params.created_at_lte = filters.created_at_lte;
            params.created_at_gte = filters.created_at_gte;
            if(filters.lvls) params['cashbackLevel_in'] = filters.lvls.map((item) => item.value);
            if (filters.type && filters.type.value !== 'all') params.operationType = filters.type.value;
            if (filters.points && filters.points.length > 0) {
                const pointsId = filters.points.map((point) => point.value).filter((item) => item);
                params.pointsId = pointsId;
            } else if (filters.point) {
                params.pointsId = [filters.point];
            } else if (filters.regionalDirectors && filters.regionalDirectors.length > 0) {
                const pointsId = filters.regionalDirectors.flatMap((dir) => {
                    if (dir && dir.points) {
                        const points = dir.points.map((point) => {
                            if (point) {
                                if (point.id) return point.id;
                                return point;
                            }
                            return null;
                        }).filter((item) => item);
                        return points;
                    }
                    return null;
                }).filter((item) => item);
                params.pointsId = pointsId;
            }
            params._sort = 'id:asc'

            const result = await getDataCursorPaging(params, {method: 'post', url: `${urls.cashbacklogs}/newListReport`});
            if (result.error) {
                dispatch({ type: 'SET_REPORTS_LOADER', name: fieldReport, loading: false });
                dispatch(setError(result.error, fieldReport));
                return false;
            }

            dispatch({ type: 'SET_REPORTS', name: fieldReport, result });
            dispatch({ type: 'SET_REPORTS_LOADER', name: fieldReport, loading: false });
            return true;
        } catch (error) {
            dispatch(setError(error, fieldReport));
            dispatch({ type: 'SET_REPORTS_LOADER', name: fieldReport, loading: false });
            return false;
        }
    }
}

export function fetchDeletedUsersReport(dataParams = {}, fieldReport) {
    return async (dispatch, getState) => {
        try {
            dispatch({ type: 'SET_REPORTS_LOADER', name: fieldReport, loading: true });
            dispatch({ type: 'SET_ERROR', name: fieldReport, error: null });
            const filters = getState().reports[fieldReport].filters;
            const prevZones = getState().reports[fieldReport].zones;

            let zonesResult = prevZones || [];
            let pointsIds = [];
            if (filters.points && filters.points.length > 0) {
                const pointsId = filters.points.map((point) => point.value).filter((item) => item);
                pointsIds = pointsId;
            } else if (filters.point) {
                pointsIds = [filters.point];
            } else if (filters.regionalDirectors && filters.regionalDirectors.length > 0) {
                const pointsId = filters.regionalDirectors.flatMap((dir) => {
                    if (dir && dir.points) {
                        const points = dir.points.map((point) => {
                            if (point) {
                                if (point.id) return point.id;
                                return point;
                            }
                            return null;
                        }).filter((item) => item);
                        return points;
                    }
                    return null;
                }).filter((item) => item);
                pointsIds = pointsId;
            }


            if (pointsIds && pointsIds.length > 0) {
                const zonesParams = { 'point_in': pointsIds };
                if (zonesResult && zonesResult.length > 0) {
                    zonesParams.id_nin = zonesResult.map((zone) => zone.id);
                }
                const zones = await getDataCursorPaging(zonesParams, {method: 'get', url: `${urls.zone}/crm`}, true);
                if (zones.error) {
                    dispatch(setError(zones.error, fieldReport));
                } else {
                    zonesResult = [...zonesResult, ...zones];
                    dispatch({ type: 'SET_REPORTS_FIELD', name: fieldReport, field: 'zones', data: zonesResult });
                }
            };

            if(!filters.created_at_gte) filters.created_at_gte = moment().endOf('day').toDate();
            if(!filters.created_at_lte) filters.created_at_lte = moment().startOf('day').toDate();
            
            const params = { ...dataParams };
            params.last_deleted_at_lte = filters.created_at_lte;
            params.last_deleted_at_gte = filters.created_at_gte;
            params._sort = 'id:asc'
            if (pointsIds && pointsIds.length > 0) params.pointsIds = pointsIds;
            if (zonesResult && zonesResult.length > 0) params.zonesIds = zonesResult.map((zone) => zone.id);

            const users = await getDataCursorPaging(params, {method: 'get', url: `${urls.statistics}/deletedUsers`}, true);
            if (users.error) {
                dispatch({ type: 'SET_REPORTS_LOADER', name: fieldReport, loading: false });
                dispatch(setError(users.error, fieldReport));
                return false;
            }
            
            const result = users.map((user) => {
                if (user.zone && parseInt(user.zone)) {
                    const zone = zonesResult.find((zone) => parseInt(zone.id) === parseInt(user.zone));
                    return { ...user, point: zone.point };
                }
                if (user.points && user.points.length > 0) return { ...user, point: user.points[0]};
                return { ...user, point: null };
            });

            dispatch({ type: 'SET_REPORTS', name: fieldReport, result });
            dispatch({ type: 'SET_REPORTS_LOADER', name: fieldReport, loading: false });
            return true;
        } catch (error) {
            dispatch(setError(error, fieldReport));
            dispatch({ type: 'SET_REPORTS_LOADER', name: fieldReport, loading: false });
            return false;
        }
    }
}

export function fetchDeliveryArticles(fieldReport) {
    return async (dispatch, getState) => {
        const settings = getState().settings.init;
        if (!settings || !settings.articlesCash || isEmpty(settings.articlesCash) || !settings.articlesCash.delivery) return dispatch({type: 'SET_REPORTS_ERROR', name: fieldReport, error: 'Категория статей расходов "Доставка" не настроена, обратитесь к администратору.' });
        
        const deliveryArticles = await request({ method: 'get', url: urls.articlesCash, params: { category: parseInt(settings.articlesCash.delivery, 10) } });
        if (isEmpty(deliveryArticles)) return dispatch({type: 'SET_REPORTS_ERROR', name: fieldReport, error: 'Не найдено статей в категории статей расходов "Доставка", обратитесь к администратору.' });
        
        const deliveryArticleIds = (deliveryArticles || []).map((article) => parseInt(article.id)).filter((id) => id)
        if (isEmpty(deliveryArticleIds)) return dispatch({type: 'SET_REPORTS_ERROR', name: fieldReport, error: 'Не найдено статей в категории статей расходов "Доставка", обратитесь к администратору.' });

        const filters = getState().reports[fieldReport].filters;

        try {
            dispatch({type: 'SET_REPORTS_ERROR', name: fieldReport, error: null });
            const params = { ids: deliveryArticleIds }

            if(!filters.created_at_gte) filters.created_at_gte = moment().endOf('day').toDate();
            if(!filters.created_at_lte) filters.created_at_lte = moment().startOf('day').toDate();

            params.opened_at_lte = filters.created_at_lte;
            params.opened_at_gte = filters.created_at_gte;

            let pointsIds = [];
            if (filters.points && filters.points.length > 0) {
                const pointsId = filters.points.map((point) => point.value).filter((item) => item);
                pointsIds = pointsId;
            } else if (filters.point) {
                pointsIds = [filters.point];
            } else if (filters.regionalDirectors && filters.regionalDirectors.length > 0) {
                const pointsId = filters.regionalDirectors.flatMap((dir) => {
                    if (dir && dir.points) {
                        const points = dir.points.map((point) => {
                            if (point) {
                                if (point.id) return point.id;
                                return point;
                            }
                            return null;
                        }).filter((item) => item);
                        return points;
                    }
                    return null;
                }).filter((item) => item);
                pointsIds = pointsId;
            }

            if (pointsIds && pointsIds.length > 0) params.pointsIds = pointsIds;

            const result = await request({ method: 'post', url: `${urls.workingShift}/fetchByArticle`, data: params });
            const groupedArticles = Object.values(
                result.reduce((acc, workingShift) => {
                    const deliveryItems = (workingShift.articlesCashes || []).filter((article) => deliveryArticleIds.includes(article.articleId) && article.typeMovementCash === 'expenditure');
            
                    const total = deliveryItems.reduce((sum, item) => {
                        const value = parseFloat(item.sum) || 0;
                        return sum + value;
                    }, 0);
            
                    const point = workingShift.point;
                    const pointId = point ? (point.id ? point.id : point) : null;
            
                    const date = moment(workingShift.opened_at).format('DD.MM.YYYY');
            
                    const key = `${pointId}_${date}`;
            
                    if (!acc[key]) acc[key] = { pointId, date, sum: 0 };
            
                    acc[key].sum = parseNumToFixed((acc[key].sum || 0) + total);
            
                    return acc;
                }, {})
            );

            dispatch({ type: 'SET_REPORTS_FIELD', name: fieldReport, field: 'deliveryArticles', data: groupedArticles });
            dispatch({ type: 'SET_REPORTS_LOADER', name: fieldReport, loading: false });
        } catch (error) {
            dispatch({ type: 'SET_REPORTS_LOADER', name: fieldReport, loading: false });
            dispatch(setError(error, fieldReport));
            return false
        }
        
    }
}

export function fetchWorkingShiftByArticle(article, fieldReport, fieldArticle) {
    return async (dispatch, getState) => {
        const settings = getState().settings.init;
        if (!settings || !settings.articlesCash || isEmpty(settings.articlesCash) || !settings.articlesCash.delivery) return dispatch({type: 'SET_REPORTS_ERROR', name: fieldReport, error: 'Категория статей расходов "Доставка" не настроена, обратитесь к администратору.' });
        

        const filters = getState().reports[fieldReport].filters;

        try {
            dispatch({type: 'SET_REPORTS_ERROR', name: fieldReport, error: null });
            const params = { ids: [article] }

            if(!filters.created_at_gte) filters.created_at_gte = moment().endOf('day').toDate();
            if(!filters.created_at_lte) filters.created_at_lte = moment().startOf('day').toDate();

            params.opened_at_lte = filters.created_at_lte;
            params.opened_at_gte = filters.created_at_gte;

            let pointsIds = [];
            if (filters.points && filters.points.length > 0) {
                const pointsId = filters.points.map((point) => point.value).filter((item) => item);
                pointsIds = pointsId;
            } else if (filters.point) {
                pointsIds = [filters.point];
            } else if (filters.regionalDirectors && filters.regionalDirectors.length > 0) {
                const pointsId = filters.regionalDirectors.flatMap((dir) => {
                    if (dir && dir.points) {
                        const points = dir.points.map((point) => {
                            if (point) {
                                if (point.id) return point.id;
                                return point;
                            }
                            return null;
                        }).filter((item) => item);
                        return points;
                    }
                    return null;
                }).filter((item) => item);
                pointsIds = pointsId;
            }

            if (pointsIds && pointsIds.length > 0) params.pointsIds = pointsIds;

            const result = await request({ method: 'post', url: `${urls.workingShift}/fetchByArticle`, data: params });

            const groupedArticles = Object.values(
                result.reduce((acc, workingShift) => {
                    const deliveryItems = (workingShift.articlesCashes || []).filter((workingShiftArticle) => [article].includes(workingShiftArticle.articleId) && workingShiftArticle.typeMovementCash === 'expenditure');
            
                    const total = deliveryItems.reduce((sum, item) => {
                        const value = parseFloat(item.sum) || 0;
                        return sum + value;
                    }, 0);
            
                    const point = workingShift.point;
                    const pointId = point ? (point.id ? point.id : point) : null;
            
                    const date = moment(workingShift.opened_at).format('DD.MM.YYYY');
            
                    const key = `${pointId}_${date}`;
            
                    if (!acc[key]) acc[key] = { pointId, date, sum: 0 };
            
                    acc[key].sum = parseNumToFixed((acc[key].sum || 0) + total);
            
                    return acc;
                }, {})
            );

            dispatch({ type: 'SET_REPORTS_FIELD', name: fieldReport, field: fieldArticle, data: groupedArticles });
            dispatch({ type: 'SET_REPORTS_LOADER', name: fieldReport, loading: false });
        } catch (error) {
            dispatch({ type: 'SET_REPORTS_LOADER', name: fieldReport, loading: false });
            dispatch(setError(error, fieldReport));
            return false
        }
        
    }
}

export function fetchUnactiveUsersCount() {
    return async (dispatch, getState) => {
        dispatch({ type: 'SET_REPORTS_LOADER', name: 'unactiveClients', loading: true });
        dispatch({ type: 'SET_ERROR', name: 'unactiveClients', error: null });
        const filters = getState().reports.unactiveClients.filters;

        if(!filters.last_order_lte) filters.last_order_lte = moment().startOf('day').toDate();
        
        const params = {};
        params.last_order_lte = filters.last_order_lte;
        params['role.id_in'] = [roleId.client];

        if (!isEmpty(filters.city) && filters.city.value) params.city = [parseInt(filters.city.value)];

        try {
            const count = await request({ method: 'get', url: urls.counter+'/users', params });

            dispatch({ type: 'SET_REPORTS_FIELD', name: 'unactiveClients', field: 'count', data: count });
            dispatch({ type: 'SET_REPORTS_LOADER', name: 'unactiveClients', loading: false });
        } catch (error) {
            dispatch(setError(error, 'unactiveClients'));
            dispatch({ type: 'SET_REPORTS_LOADER', name: 'unactiveClients', loading: false });
            return false;
        }
    }
}

export function fetchUnactiveUsers() {
    return async (dispatch, getState) => {
        dispatch({ type: 'SET_REPORTS_LOADER', name: 'unactiveClients', loading: true });
        dispatch({ type: 'SET_ERROR', name: 'unactiveClients', error: null });
        const filters = getState().reports.unactiveClients.filters;
        const points = getState().handbook.filials;
        const zones = getState().handbook.zones;
        const zonesArray = [...(zones || [])];

        if(!filters.last_order_lte) filters.last_order_lte = moment().startOf('day').toDate();
        
        const params = {};
        params.last_order_lte = filters.last_order_lte;
        params.roleId = roleId.client;

        if (!isEmpty(filters.city) && filters.city.value) params.city = [parseInt(filters.city.value)];

        const getPoint = (user, id) => {
            const point = points.find((filial) => filial.id === id);
            if (!point) return { ...user, point: null}
            return { ...user, point, zone: null };
        }

        params['_sort'] = 'last_order:desc';

        try {
            const users = await request({ method: 'get', url: `${urls.statistics}/unactiveUsers`, params });

            const result = await Promise.all(users.map(async (user) => {
                if (!user.points && !user.zone) return user;
                if (user.points && user.points[0]) {
                    const point = user.points[0];
                    if (point.id) return getPoint(user, point.id);
                    return getPoint(user, point);
                }
                if (user.zone && parseInt(user.zone) != null) {
                    const zoneId = parseInt(user.zone);
                    let zone = zonesArray.find((z) => z.id === zoneId);
                    if (zone && zone.id && zone.point) {
                        if (zone.point.id) return { ...user, point: zone.point };
                        return getPoint(user, zone.point)
                    } else {
                        zone = await request({ method: 'get', url: `${urls.zone}/${zoneId}`, params: { isCrm: true } }).catch(() => null);
                        if (zone) {
                            zonesArray.push(zone);
                            if (zone.point.id) return { ...user, point: zone.point };
                            return getPoint(user, zone.point)
                        }
                    }
                }
                return { ...user, point: null, zone: null };
            }));
            dispatch({ type: 'SET_REPORTS_LOADER', name: 'unactiveClients', loading: false });
            return result;
        } catch (error) {
            dispatch(setError(error, 'unactiveClients'));
            dispatch({ type: 'SET_REPORTS_LOADER', name: 'unactiveClients', loading: false });
            return false;
        }        
    }
}

export function createIncomeStatement(data) {
    return async (dispatch) => {
        dispatch({ type: 'SET_REPORTS_LOADER', name: 'incomeStatement', loading: true });
        dispatch({ type: 'SET_ERROR', name: 'incomeStatement', error: null });

        try {
            const result = await request({ method: 'post', url: urls.incomestatements, data});
            dispatch({ type: 'SET_REPORTS_FIELD', name: 'incomeStatement', field: 'result', data: result });
            dispatch({ type: 'SET_REPORTS_LOADER', name: 'incomeStatement', loading: false });
        } catch (error) {
            dispatch(setError(error, 'incomeStatement'));
            dispatch({ type: 'SET_REPORTS_LOADER', name: 'incomeStatement', loading: false });
            return false;
        }
    }
}

export function updateIncomeStatement(data, id) {
    return async (dispatch) => {
        dispatch({ type: 'SET_REPORTS_LOADER', name: 'incomeStatement', loading: true });
        dispatch({ type: 'SET_ERROR', name: 'incomeStatement', error: null });

        try {
            const result = await request({ method: 'put', url: `${urls.incomestatements}/${id}`, data});
            dispatch({ type: 'SET_REPORTS_FIELD', name: 'incomeStatement', field: 'result', data: result });
            dispatch({ type: 'SET_REPORTS_LOADER', name: 'incomeStatement', loading: false });
        } catch (error) {
            dispatch(setError(error, 'incomeStatement'));
            dispatch({ type: 'SET_REPORTS_LOADER', name: 'incomeStatement', loading: false });
            return false;
        }
    }
}

export function fetchReportIncomeStatement(force) {
    return async (dispatch, getState) => {
        if (!force) dispatch({ type: 'SET_REPORTS_INCOME_STATEMENT', name: 'incomeStatement', orders: [], workingShifts: [], otherExpenditures: [], result: null });

        dispatch({ type: 'SET_REPORTS_LOADER', name: 'incomeStatement', loading: true });
        dispatch({ type: 'SET_ERROR', name: 'incomeStatement', error: null });
        const filters = getState().reports.incomeStatement.filters;
        const points = getState().handbook.filials;
        const zones = getState().handbook.zones;
        const zonesArray = [...(zones || [])];

        if(!filters.month) filters.month = new Date(moment().subtract(1, 'months').startOf('month'));
        
        const params = {};
        if (!filters.point || !filters.point.value || !filters.month) return;
        const start = moment(filters.month).startOf('month').format('YYYY-MM-DD HH:mm:ss');
        const end = moment(filters.month).endOf('month').format('YYYY-MM-DD HH:mm:ss');

        const paramsWorkingshhifts = {
            point: filters.point.value,
            created_at_gte: start,
            created_at_lte: end,
        }

        try {
            const workingShifts = await getDataCursorPaging(paramsWorkingshhifts, {method: 'post', url: `${urls.workingShift}/listReportIncomeStatement`});
            if (workingShifts.error) {
                dispatch({ type: 'SET_REPORTS_LOADER', name: 'incomeStatement', loading: false });
                dispatch(setError(workingShifts.error, 'incomeStatement'));
                return false;
            }

            const otherExpenditures = await getDataCursorPaging(paramsWorkingshhifts, {method: 'post', url: `${urls.otherExpenditures}/listReportIncomeStatement`});
            if (otherExpenditures.error) {
                dispatch({ type: 'SET_REPORTS_LOADER', name: 'incomeStatement', loading: false });
                dispatch(setError(otherExpenditures.error, 'incomeStatement'));
                return false;
            }

            let report;

            if (!force) {
                const paramsReport = {
                    _limit: 1,
                    pointId: filters.point.value,
                    month: filters.month,
                }

                report = await request({ method: 'get', url: urls.incomestatements, params: paramsReport});
            }

            if (report && report[0]) {
                dispatch({ type: 'SET_REPORTS_INCOME_STATEMENT', result: report[0], name: 'incomeStatement', orders: [], workingShifts, otherExpenditures });
                dispatch({ type: 'SET_REPORTS_LOADER', name: 'incomeStatement', loading: false });
            } else {
                params.workingShiftIds = workingShifts.map((item) => +item.id).filter((item) => item);

                if (filters.status) params.status = filters.status;

                const orders = await getDataCursorPaging(params, {method: 'post', url: `${urls.orders}/listReportIncomeStatement`});
                if (orders.error) {
                    dispatch({ type: 'SET_REPORTS_LOADER', name: 'incomeStatement', loading: false });
                    dispatch(setError(orders.error, 'incomeStatement'));
                    return false;
                }
                const archive = await getDataCursorPaging(params, {method: 'post', url: `${urls.archive}/listReportIncomeStatement`});
                if (archive.error) {
                    dispatch({ type: 'SET_REPORTS_LOADER', name: 'incomeStatement', loading: false });
                    dispatch(setError(archive.error, 'incomeStatement'));
                    return false;
                }

                const getPoint = (order, id) => {
                    const point = points.find((filial) => filial.id === id);
                    if (!point) return { ...order, point: null}
                    return { ...order, point, zone: null };
                }

                const resultOrders = await Promise.all([...(orders || []), ...(archive || [])].map(async (order) => {
                    if (!order.point && !order.zone) return order;
                    if (!isEmpty(order.aggData) && typeof order.aggData === 'string') order.aggData = JSON.parse(order.aggData);
                    if (order.point) {
                        if (order.point.id) return order;
                        return getPoint(order, order.point)
                    }
                    if (order.zone) {
                        if (order.zone.id) {
                            if (order.zone.point) {
                                if (order.zone.point.id) return { ...order, point: order.zone.point };
                                return getPoint(order, order.zone.point)
                            }
                        }
                        let zone = zonesArray.find((z) => z.id === order.zone);
                        if (zone && zone.id && zone.point) {
                            if (zone.point.id) return { ...order, point: zone.point };
                            return getPoint(order, zone.point)
                        } else {
                            zone = await request({ method: 'get', url: `${urls.zone}/${order.zone}` }).catch(() => null);
                            if (zone) {
                                zonesArray.push(zone);
                                if (zone.point.id) return { ...order, point: zone.point };
                                return getPoint(order, zone.point)
                            }
                        }
                    }
                    return { ...order, point: null, zone: null };
                }));

                dispatch({ type: 'SET_REPORTS_FIELD', name: 'incomeStatement', field: 'orders', data: resultOrders });
                dispatch({ type: 'SET_REPORTS_FIELD', name: 'incomeStatement', field: 'workingShifts', data: workingShifts });
                dispatch({ type: 'SET_REPORTS_FIELD', name: 'incomeStatement', field: 'otherExpenditures', data: otherExpenditures });
                dispatch({ type: 'SET_REPORTS_LOADER', name: 'incomeStatement', loading: false });
            }
        } catch (error) {
            dispatch(setError(error, 'incomeStatement'));
            dispatch({ type: 'SET_REPORTS_LOADER', name: 'incomeStatement', loading: false });
            return false;
        }
    }
}